import React from "react";

import { Link } from "react-router-dom";
import { Table, Alert } from "antd";

import { LAYOUT_FINANCE_INVOICE_CLIENT_ASSIGN_JOB } from "../../../navigation";

const columnsD = [
    {
        title: "Description",
        dataIndex: "task",
        key: "task",
    },
    {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        align: "right",
        width: 50,
    },
    {
        title: "Unit",
        dataIndex: "unit",
        key: "unit",
        align: "right",
        width: 50,
    },

    {
        title: "Rate",
        dataIndex: "rateValue",
        key: "rateValue",
        align: "right",
        width: 150,
        render: (rate) => {
            return <>{rate}</>;
        },
    },
    {
        title: "Subtotal",
        dataIndex: "subtotalValue",
        key: "subtotalValue",
        align: "right",
        width: 150,
        render: (subtotal) => {
            return <>{subtotal}</>;
        },
    },
];

const columns = (id, clientId) => [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "Subtotal",
        dataIndex: "subtotal",
        key: "subtotal",
        render: (subtotal) => {
            if (subtotal) return <>{subtotal.value}</>;
        },
    },
    {
        title: "Assign ... ",
        render: (record) => {
            return (
                <Link
                    to={LAYOUT_FINANCE_INVOICE_CLIENT_ASSIGN_JOB(
                        id,
                        record.id,
                        encodeURIComponent(record.name),
                        clientId
                    )}
                >
                    Assign Job
                </Link>
            );
        },
    },
];

const JobNotFound = (props) => {
    const expandedRowClassName = (record, index, indent) => "table-finance-details";

    if ((props.notFound || []).length === 0) {
        return <></>;
    }

    return (
        <div>
            <br />
            <Alert type="error" description="The tool could not find the associative job" banner showIcon />
            <Table
                size="small"
                pagination={false}
                columns={columns(props.invoice.id, props.invoice.clientId)}
                dataSource={props.notFound || []}
                ghost={false}
                rowKey={(row) => row.name}
                expandable={{
                    expandedRowClassName,
                    expandedRowRender: (record) => (
                        <Table
                            columns={columnsD}
                            dataSource={record.data}
                            rowKey={(row) => row.id}
                            pagination={false}
                            footer={() => ""}
                        />
                    ),
                }}
                bordered
            />
        </div>
    );
};

export default JobNotFound;
